import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Avatar, TableBody, IconButton, TableHead, TableRow, TableCell, Paper, Table, TableContainer, AccordionDetails, Divider, Typography, AccordionSummary, Grid, Stack, Chip, Box, List, Accordion } from '@mui/material';
import moment from 'moment' // con esto manejamos las fechas bien
import { getData } from '../../../../services/library';
import { UrlApi } from '../../../../services/apirest';
import { verEnviarPDF } from '../../../../services/services';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { SIN_BORDE, fetchPagosRepartos, pagosDelPedido as filtrarPagosPedido, calcularCobros, FilasPagos, FilasSumatoria } from '../pagosReparto';

export default function OpenRendiciones(props) {
    const { sucursalSelected, fecha } = props;
    const [repartos, setRepartos] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [expandedRepartos, setExpandedRepartos] = useState([]);
    const [pedidosRepartos, setpedidosRepartos] = useState([]);
    const [comprobantesAsociados, setcomprobantesAsociados] = useState([]);
    const [pesadasMap, setPesadasMap] = useState([])
    const [pagosRepartos, setPagosRepartos] = useState([]);

    // Pagos vigentes (granel_pagos) de todos los repartos listados, en una sola llamada
    const getPagosRepartos = async () => {
        setPagosRepartos(await fetchPagosRepartos(repartos));
    };

    // Pagos de un pedido dentro del reparto
    const pagosDelPedido = (pedido, nroReparto) => filtrarPagosPedido(pagosRepartos, pedido, nroReparto);

    // Filas con cada pago individual del pedido (si tiene)
    const renderPagos = (pedido, nroReparto) => <FilasPagos pagos={pagosDelPedido(pedido, nroReparto)} />;

    const getRepartos = async () => {
        let query = {};

        if (sucursalSelected) query.id_sucursal = sucursalSelected;

        if (fecha) query.fecha_finalizado = moment(fecha).format('YYYY-MM-DD');

        // Construir los parámetros de consulta
        const queryParams = new URLSearchParams(query).toString();
        const endpoint = queryParams ? `/repartos/listado?${queryParams}` : '/repartos/listado';


        try {
            // obtenemos los datos
            await getData(endpoint, setRepartos);
        } catch (error) {
            console.error("Error al obtener repartos:", error);
        }
    };

    const getPedidosRepartos = async () => {
        if (!Array.isArray(repartos) || repartos.length === 0) {
            console.warn("No hay repartos disponibles.");
            return;
        }

        try {
            const pedidosPromises = repartos.map(async (r) => {
                try {
                    const response = await fetch(UrlApi + `/pedidos/inreparto/${r.nro_reparto}`);

                    if (!response.ok) {
                        throw new Error(`Error en la solicitud: ${response.statusText}`);
                    }
                    const data = await response.json();
                    return Array.isArray(data) ? data : []; // Asegura que data sea un array
                } catch (error) {
                    console.error(`Error obteniendo pedidos para reparto ${r.nro_reparto}:`, error);
                    return []; // En caso de error, retorna un array vacío para no afectar el resto
                }
            });

            const pedidosResults = await Promise.allSettled(pedidosPromises);

            const allPedidos = pedidosResults
                .filter(result => result.status === "fulfilled") // Filtra las respuestas exitosas
                .map(result => result.value) // Extrae los valores
                .flat();

            setpedidosRepartos(allPedidos);

        } catch (error) {
            console.error("Error general obteniendo pedidos:", error);
        }
    };

    const getFacturas = async () => {
        if (!Array.isArray(pedidosRepartos) || pedidosRepartos.length === 0) {
            console.log("No hay pedidos disponibles para obtener facturas");
            return;
        }

        try {
            const facturasPromises = pedidosRepartos.map(async (m) => {
                try {
                    const response = await fetch(UrlApi + `/comprobantes/facturas/${m.id}`);

                    if (!response.ok) {
                        throw new Error(`Error en la solicitud: ${response.statusText}`);
                    }
                    const data = await response.json();
                    return Array.isArray(data) ? data : []; // Asegura que data sea un array
                } catch (error) {
                    console.error(`Error obteniendo factura para pedido ${m.id}:`, error);
                    return []; // Retorna array vacío si hay error para no afectar el resto
                }
            });

            const facturasResults = await Promise.allSettled(facturasPromises);


            const allFacturas = facturasResults
                .map(result => result.value) // Extrae los valores
                .flat()
                .sort((a, b) =>
                    (b.codigo_comprobante_afip) - (a.codigo_comprobante_afip)
                );

            setFacturas(allFacturas);
        } catch (error) {
            console.error("Error general obteniendo facturas:", error);
        }
    };

    const getComprobantes = async () => {
        if (!repartos && !facturas) {
            return;
        };

        try {
            const comprobantesPromises = facturas.map((f) =>
                fetch(UrlApi + `/comprobantes/uuid/${f.uuid}`)
                    .then(response => response.json())
            );
            const comprobantesResult = await Promise.all(comprobantesPromises);
            const allComprobantes = comprobantesResult.flat();

            setcomprobantesAsociados(allComprobantes);
        } catch (error) {
            console.error("Error obteniendo los comprobantes", error)
        }
    };

    const getPesada = async () => {
        if (!repartos || !pedidos) {
            return;
        }

        try {
            const pesadasPromises = repartos.map(async (r) => {
                const response = await fetch(UrlApi + `/pedidos/pesada/${r.nro_reparto}`);
                return response.json();
            });

            const pesadasResult = await Promise.all(pesadasPromises);
            const allPesadas = pesadasResult.flat();

            // Mapear los resultados de la pesada por nro_reparto
            const pesadasMap = allPesadas.reduce((acc, item) => {
                acc[item.nro_reparto] = {
                    total_empresa1: item.total_empresa1 || 0,
                    total_empresa4: item.total_empresa4 || 0,
                };
                return acc;
            }, {});

            // Guardar el mapa en el estado
            setPesadasMap(pesadasMap);
        } catch (error) {
            console.error("Error obteniendo pesadas", error);
        }
    };

    useEffect(() => {
        getRepartos()
    }, [fecha]);

    useEffect(() => {
        getRepartos()
    }, [])

    useEffect(() => {
        if (repartos) {
            getPedidosRepartos()
            getPesada()
            getPagosRepartos()
        }
    }, [repartos]);

    useEffect(() => {
        if (pedidosRepartos) {

            getFacturas();
        }
    }, [pedidosRepartos]);

    const handleAccordionChange = (idreparto) => {
        setExpandedRepartos((prevState) => ({
            ...prevState,
            [idreparto]: !prevState[idreparto], // Cambiar el estado de expansión
        }));
        getComprobantes();
    };

    const noHayNadaParaMostrar = <>
        <Card>
            <CardHeader
                avatar={<Avatar sx={{ backgroundColor: "red" }}>!</Avatar>}
                title="No hay repartos finalizados."
            />

        </Card>
    </>

    return (
        <div>

            <Box sx={{ width: '100%', }}>
                {/* Mostrar resultados de repartos */}
                <List>
                    {repartos.length > 0 ? repartos.map((rendicion) => (
                        <Accordion
                            key={rendicion.idreparto}
                            sx={{ mb: 0.5, borderRadius: 2, boxShadow: 2, width: "100%" }}
                            expanded={expandedRepartos[rendicion.idreparto]} // Determinar si el acordeón está expandido
                            onChange={() => handleAccordionChange(rendicion.idreparto)} // Cambiar el estado al hacer clic
                        >
                            {/* <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "#f5f5f5" }}>
                                <Box display="flex" flexDirection="column">
                                    <Typography variant="button" fontWeight="bold">
                                        PLANILLA DE REPARTO N° {rendicion.nro_remito} {`(${rendicion.sucursal_atiende})`}
                                    </Typography>
                                    <Typography variant="button" fontWeight="bold">
                                        CHOFER: {`${rendicion.nombrepila} ${rendicion.apellido}`} VEHICULO: {`(${rendicion.patente})`}
                                    </Typography>
                                </Box>
                            </AccordionSummary> */}
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{
                                    bgcolor: '#f5f5f5',
                                    borderBottom: '1px solid #ddd',
                                    '&:hover': { bgcolor: '#e8f4fd' } // Efecto hover
                                }}
                            >
                                <Stack direction="row" alignItems="center" spacing={2} width="100%">

                                    {/* Información principal */}
                                    <Box >
                                        <Typography variant="subtitle1" fontWeight="bold" color="#000000">
                                            Planilla N° {rendicion.nro_remito}
                                        </Typography>
                                        <Chip label={`Chofer: ${rendicion.nombrepila} ${rendicion.apellido}`} size="small" />
                                        <Chip label={`Vehículo: ${rendicion.patente}`} size="small" color="default" />
                                    </Box>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: 2 }}>
                                <Divider sx={{ borderColor: "#ccc" }} />

                                {/* Información General */}
                                <Grid container direction="column" spacing={2} sx={{ mb: 0.5 }}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            Información General:
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Fecha: {moment(rendicion.fecha_salida_reparto).format("DD-MM-YYYY")}<br />
                                            Km inicial: {rendicion.km_iniciales} - Km final: {rendicion.km_finales}<br />
                                            Diferencia: {rendicion.km_finales - rendicion.km_iniciales} km<br />
                                            Chofer: {rendicion.nombrepila + " " + rendicion.apellido}<br />
                                            Peso inicial: {rendicion.peso_bruto_inicial} - Peso final: {rendicion.peso_bruto_final}<br />
                                            Diferencia de kilos: {rendicion.peso_bruto_inicial - rendicion.peso_bruto_final}<br />
                                            Pta carga: {rendicion.nombre}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider sx={{ my: 2, borderColor: "#ddd" }} />

                                {/* Detalle de Comprobante de Venta */}
                                {(() => {
                                    if (!pedidosRepartos || !facturas) {
                                        return (
                                            <Typography variant="button" color="textSecondary" sx={{ mt: 2 }}>
                                                No hay datos disponibles.
                                            </Typography>
                                        );
                                    }

                                    const pedidosDelReparto = pedidosRepartos.filter((pedido) => pedido.nro_reparto === rendicion.nro_reparto);

                                    if (pedidosDelReparto.length === 0) {
                                        return (
                                            <Typography variant="button" color="textSecondary" sx={{ mt: 2 }}>
                                                No hay pedidos en este reparto.
                                            </Typography>
                                        );
                                    }

                                    // Sumatoria desde granel_pagos (ver calcularCobros en ../pagosReparto)
                                    const totales = calcularCobros({
                                        pedidos: pedidosDelReparto,
                                        pagos: pagosRepartos,
                                        facturas,
                                        nroReparto: rendicion.nro_reparto,
                                    });


                                    return (
                                        <>
                                            <Typography variant="button" fontWeight="bold" sx={{ mt: 2 }}>
                                                DETALLE DE COMPROBANTE DE VENTA:
                                            </Typography>
                                            <TableContainer component={Paper} sx={{ mt: 2, mb: 3, borderRadius: 1, boxShadow: 1 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ bgcolor: "#e0e0e0" }}>
                                                            {comprobantesAsociados?.length > 0 || facturas?.length > 0 ? (
                                                                <>
                                                                    <TableCell>Comprobante</TableCell>
                                                                    <TableCell>Razón Social</TableCell>
                                                                    <TableCell align="right">Importe Total</TableCell>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <TableCell sx={{ bgcolor: "#FFCDD2" }}>Pedido</TableCell>
                                                                    <TableCell sx={{ bgcolor: "#FFCDD2" }}>Razón Social</TableCell>
                                                                    <TableCell sx={{ bgcolor: "#FFCDD2" }} align="right">Estado</TableCell>
                                                                </>
                                                            )}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {pedidosDelReparto.map((pedido) => {
                                                            // Obtener y ordenar las facturas antes de filtrar
                                                            const facturasDelPedido = facturas
                                                                ?.filter((factura) => factura.id_pedido === pedido.id);


                                                            // Filtrar los comprobantes después de ordenar las facturas
                                                            const comprobantesDelPedido = comprobantesAsociados?.filter((comprobante) =>
                                                                facturasDelPedido.some((factura) => factura.uuid === comprobante.compr_asoc)
                                                            );

                                                            const tienePagos = pagosDelPedido(pedido, rendicion.nro_reparto).length > 0;

                                                            if (pedido.id_estado === 25 || pedido.id_estado === 263 || pedido.id_estado === 337) {
                                                                const tieneAsociados = comprobantesDelPedido.length > 0;
                                                                return (
                                                                    <React.Fragment key={pedido.id}>
                                                                        {facturasDelPedido.map((factura, index) => (
                                                                            <TableRow
                                                                                key={factura.id_factura}
                                                                                sx={index < facturasDelPedido.length - 1 || tieneAsociados || tienePagos ? SIN_BORDE : undefined}
                                                                            >
                                                                                <TableCell>{`(${factura.pto_venta} - ${factura.nro_comprobante}) ${factura.texto_comprobante} ${factura.letra} `}
                                                                                    <IconButton onClick={() => verEnviarPDF(factura.id_factura, 0)}>
                                                                                        <PictureAsPdfIcon color="secondary" />
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {factura.nro_sisven
                                                                                        ? `(${factura.nro_sisven}) ${factura.razon_social}`
                                                                                        : factura.razon_social}
                                                                                </TableCell>
                                                                                <TableCell align="right">${factura.importe_total}</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                        {/* Renderizar comprobantes asociados una sola vez */}
                                                                        {comprobantesDelPedido.length > 0 && (
                                                                            <TableRow sx={{ bgcolor: "#E3F2FD", ...(tienePagos ? SIN_BORDE : {}) }}>
                                                                                <TableCell colSpan={2}>
                                                                                    {`Comprobante asociado: `}
                                                                                    {comprobantesDelPedido.map((comprobante, index) => (
                                                                                        <span key={comprobante.id_factura}>
                                                                                                {`${comprobante.texto_comprobante} ${comprobante.letra} Cliente: ${comprobante.razon_social}`} {`Factura:`} {comprobante.nro_comprobante_asociado}
                                                                                                <IconButton onClick={() => verEnviarPDF(comprobante.id_factura, 0)}>
                                                                                                    <PictureAsPdfIcon color="secondary" />
                                                                                                </IconButton>
                                                                                                {index < comprobantesDelPedido.length - 1 && ", "}
                                                                                            </span>
                                                                                    ))}
                                                                                </TableCell>
                                                                                <TableCell align="right">
                                                                                    {comprobantesDelPedido.reduce((total, comprobante) => total + comprobante.importe_total, 0).toFixed(2)}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                        {renderPagos(pedido, rendicion.nro_reparto)}
                                                                    </React.Fragment>
                                                                );
                                                            } else {

                                                                return (
                                                                    <React.Fragment key={pedido.id}>
                                                                        <TableRow sx={{ bgcolor: "#FFCDD2", ...(tienePagos ? SIN_BORDE : {}) }}>
                                                                            <TableCell>{pedido.id}</TableCell>
                                                                            <TableCell>{pedido.razon_social}</TableCell>
                                                                            <TableCell align="right">{pedido.estado}</TableCell>
                                                                        </TableRow>
                                                                        {renderPagos(pedido, rendicion.nro_reparto)}
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                        })}


                                                        {facturas?.length > 0 && <FilasSumatoria totales={totales} />}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </>
                                    );
                                })()}

                                {/* Detalles de Remitos */}
                                <Divider sx={{ my: 2, borderColor: "#ddd" }} />
                                <Typography variant="button" fontWeight="bold" sx={{ mt: 2 }}>DETALLES DE REMITOS DE VENTA/COMODATO:</Typography>
                                <TableContainer component={Paper} sx={{ mt: 2, mb: 3, borderRadius: 1, boxShadow: 1, width: "100%" }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: "#e0e0e0" }}>
                                                <TableCell>Pedido</TableCell>
                                                <TableCell>Nro. Remito</TableCell>
                                                <TableCell>Razón Social</TableCell>
                                                <TableCell>Producto</TableCell>
                                                <TableCell>Sucursal</TableCell>
                                                <TableCell>Empresa</TableCell>
                                                <TableCell>Kgs entregados</TableCell>
                                                <TableCell>Lts entregados</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {pedidosRepartos
                                                .filter(
                                                    (pedido) =>
                                                        pedido.nro_reparto === rendicion.nro_reparto &&
                                                        pedido.nro_remito !== null // Filtra donde nro_remito no sea null
                                                )
                                                .map((pedido) => (
                                                    <TableRow key={pedido.id}>
                                                        <TableCell>{pedido.id}</TableCell>
                                                        <TableCell>{pedido.nro_remito}</TableCell>
                                                        <TableCell>{pedido.sisven_id ? `(${pedido.sisven_id}) ${pedido.razon_social}` : `${pedido.razon_social}`}</TableCell>
                                                        <TableCell>{pedido.nombre_producto}</TableCell>
                                                        <TableCell>{pedido.nombre_sucursal}</TableCell>
                                                        <TableCell>{pedido.empresa}</TableCell>
                                                        <TableCell>{pedido.kgentregados ?? "-"}</TableCell>
                                                        <TableCell>{pedido.ltsentregados ?? "-"}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                        {/* Calcular sumatorias */}
                                        {(() => {
                                            const totalKgs = pedidosRepartos
                                                .filter((pedido) =>
                                                    pedido.nro_reparto === rendicion.nro_reparto &&
                                                    pedido.nro_remito !== null
                                                )
                                                .reduce((acc, pedido) => acc + (pedido.kgentregados || 0), 0);

                                            const totalLts = pedidosRepartos
                                                .filter((pedido) =>
                                                    pedido.nro_reparto === rendicion.nro_reparto &&
                                                    pedido.nro_remito !== null
                                                )
                                                .reduce((acc, pedido) => acc + (pedido.ltsentregados || 0), 0);

                                            return (
                                                <>
                                                    <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                                        <TableCell align="right" colSpan={4} fontWeight="bold">
                                                            <strong>Total KILOS</strong>
                                                        </TableCell>
                                                        <TableCell align="right" fontWeight="bold">
                                                            {totalKgs}
                                                        </TableCell>
                                                        <TableCell align="right" colSpan={1} fontWeight="bold">
                                                            <strong>Total LITROS</strong>
                                                        </TableCell>
                                                        <TableCell align="right" fontWeight="bold">
                                                            {totalLts}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            );
                                        })()}
                                    </Table>


                                </TableContainer>
                                <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                    <TableCell align="right" colSpan={4} style={{ fontWeight: 'bold' }}>
                                        Total KILOS HIPERGAS:
                                        <strong>
                                            {pesadasMap[rendicion.nro_reparto]?.total_empresa1?.toFixed(2) || "0.00"}
                                        </strong>
                                    </TableCell>
                                    <TableCell align="right" colSpan={4} style={{ fontWeight: 'bold' }}>
                                        Total KILOS NATURAL GAS:
                                        <strong>
                                            {pesadasMap[rendicion.nro_reparto]?.total_empresa4?.toFixed(2) || "0.00"}
                                        </strong>
                                    </TableCell>
                                </TableRow>
                                {/* Mostrar la diferencia entre venta y pesada */}
                                <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                    <TableCell align="right" colSpan={8} style={{ fontWeight: 'bold' }}>
                                        DIFERENCIA VENTA/PESADA:
                                        <strong>
                                            {((pesadasMap[rendicion.nro_reparto]?.total_empresa4 || 0) +
                                                (pesadasMap[rendicion.nro_reparto]?.total_empresa1 || 0) -
                                                (rendicion.peso_bruto_inicial - rendicion.peso_bruto_final)).toFixed(2)}
                                        </strong>
                                    </TableCell>
                                </TableRow>
                            </AccordionDetails>
                        </Accordion>
                    )) :
                        <Grid item xs={12} sm={12} md={12}>
                            <>
                                {noHayNadaParaMostrar}
                            </>
                        </Grid>
                    }
                </List>
            </Box>
        </div>
    )
}
